import { isMobile } from '@shared/innmaxLib/utils/browser-detect'
import React from 'react'

export default function useViewport() {
  const [_isMobile, setIsMobile] = React.useState(isMobile())

  React.useEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    window.addEventListener('orientationchange', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
      window.removeEventListener('orientationchange', handleResize)
    }
  }, []) // eslint-disable-line

  const handleResize = () => {
    setIsMobile(window.innerWidth < 1024 || isMobile())
  }

  return {
    isMobile: _isMobile,
  }
}
